/**
 * Created by tuannguyenla on 6/1/2016.
 */
declare const $:any;
export class Notification {
  public static notify(parent, type = 'info', errMessage, position = 'top', style = 'bar') {
    if (!parent) {
      parent = $('body');
    }
    //noinspection TypeScriptUnresolvedFunction
    parent.pgNotification({
      style: style,
      message: errMessage,
      position: position,
      timeout: 5000,
      type: type
    }).show()
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/common/notification.ts